export type ContactT = {
  text: string;
  value: string | null;
  icon: string;
  type: "address" | "phone" | "email";
  owner: "segreteria" | "davide" | "ivano" | "fax" | null;
};

export const OWNER_CONVERTED: Record<string, string> = {
  segreteria: "Segreteria",
  davide: "Davide Violato",
  ivano: "Ivano Violato",
};

export const CONTACTS: ContactT[] = [
  {
    text: "Via Vittorio Emanuele II n.41/1, 35026 Conselve PD",
    value: null,
    icon: "location",
    type: "address",
    owner: null,
  },
  {
    text: "commerciale@rotoinfissioni.it",
    value: "commerciale@rotoinfissioni.it",
    icon: "envelope",
    type: "email",
    owner: null,
  },

  {
    text: "rotoinfissionisrl@pec.it",
    value: "rotoinfissionisrl@pec.it",
    icon: "shield",
    type: "email",
    owner: null,
  },

  {
    text: "335.6996848",
    value: "+393356996848",
    icon: "mobile",
    type: "phone",
    owner: "segreteria",
  },

  {
    text: "340.4147436",
    value: "+393404147436",
    icon: "mobile",
    type: "phone",
    owner: "davide",
  },

  {
    text: "335.5932676",
    value: "+393355932676",
    icon: "mobile",
    type: "phone",
    owner: "ivano",
  },
];

export const TEL_SEGRETERIA = "tel:+393356996848";
export const TEL_DAVIDE = "tel:+393404147436";
export const TEL_IVANO = "tel:+393355932676";
export const MAILTO_COMMERCIAL =
  "mailto:commerciale@rotoinfissioni.it?subject=Richiesta informazioni&body=Buongiorno,";
export const MAILTO_PEC =
  "mailto:rotoinfissionisrl@pec.it?subject=Richiesta informazioni&body=Buongiorno,";
